import React, { useEffect, useState } from "react";
import {
  Grid,
  FormControlLabel,
  DialogContent,
  Checkbox,
  DialogActions,
  Button,
  Divider
} from "@material-ui/core";
import { useQuery, useMutation } from "@apollo/client";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  signupPlanModuleBySignupPlanIdRootQuery,
  deleteModuleToSignuPlanMutation
} from "./signupPlansGQLQuery";
import ConfirmDialog from "../common/ConfirmDialog";

const RemoveModuleModel = (props) => {
  const [getAllModulesData, setGetAllModulesData] = useState([]);

  const { data: getPlanModulesQuery } = useQuery(
    signupPlanModuleBySignupPlanIdRootQuery,
    {
      fetchPolicy: "network-only",
      variables: { signupPlanId: parseInt(props.signupPlanId) }
    }
  );

  useEffect(() => {
    if (
      getPlanModulesQuery &&
      getPlanModulesQuery.signupPlanModuleBySignupPlanId.signupPlanModules &&
      getPlanModulesQuery.signupPlanModuleBySignupPlanId.signupPlanModules
        .length > 0
    ) {
      let allModulesData = [
        ...getPlanModulesQuery.signupPlanModuleBySignupPlanId.signupPlanModules
      ]
        .sort((a, b) =>
          a.moduleName > b.moduleName ? 1 : b.moduleName > a.moduleName ? -1 : 0
        )
        .map((qitem) => {
          let item = { ...qitem };

          item.label =
            item.moduleName.charAt(0) +
            item.moduleName
              .slice(1)
              .toLowerCase()
              .replaceAll("_", " ");
          return item;
        });

      setGetAllModulesData(allModulesData);
    }
  }, [getPlanModulesQuery]);

  const [deleteModuleToSignuPlan] = useMutation(
    deleteModuleToSignuPlanMutation,
  );

  const [selectedModuleId, setSelectedModuleId] = useState(null);
  const [isRemoveAllSystemClient, setIsRemoveAllSystemClient] = useState(null);

  const handleSubmit = () => {
    if (!selectedModuleId) return;

    let moduledata = {
      signupPlanId: parseInt(props.signupPlanId),
      moduleId: selectedModuleId,
      isRemoveAllSystemClient: isRemoveAllSystemClient
    };

    deleteModuleToSignuPlan({
      variables: { signupPlanModule: moduledata }
    })
      .then((item) => {
        if (props.onSuccess) {
          props.onSuccess();
        }
        props.handleClose();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const availableModules = getAllModulesData.filter(
    (module) =>
      !props.moduleIds.some((usedModule) => module.id === usedModule.moduleId)
  );

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        // handleSubmit();
      }}
    >
      <div style={{ flexDirection: "column", display: "flex" }}>
        <DialogContent
          // className="popoverOverflow"
          style={{
            paddingTop: 0,
            maxHeight: 300,
            overflowY: "auto"
          }}
        >
          <Grid container direction="column" style={{ marginTop: 4 }}>
            {availableModules.map((module) => (
              <Grid item xs={12} key={module.moduleId}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedModuleId === module.moduleId}
                      onChange={() =>
                        setSelectedModuleId((currentId) =>
                          currentId === module.moduleId
                            ? null
                            : module.moduleId,
                        )
                      }
                      color="primary"
                    />
                  }
                  label={module.label}
                />
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <div
            style={{ flexDirection: "column", display: "flex", width: "100%" }}
          >
            <Divider />

            <FormControlLabel
              control={
                <Checkbox
                  checked={isRemoveAllSystemClient}
                  onChange={() =>
                    setIsRemoveAllSystemClient((currentId) => !currentId)
                  }
                  color="primary"
                />
              }
              label="Remove the selected module from all System clients using this plan."
            />

            <div style={{ justifyContent: "flex-end", display: "flex" }}>
              <Button onClick={props.handleClose} color="primary">
                Cancel
              </Button>
              <ConfirmDialog
                title={"Confirm Delete"}
                body={"Are you sure you want to delete this module to plan?"}
                open={true}
                firstButton={"Cancel"}
                secondButton={"Delete"}
                onConfirm={() => {
                          handleSubmit();

                }}
                onReject={() => {}}
              >
                <Button
                  type="submit"
                  disabled={!selectedModuleId}
                  color="primary"
                >
                  Save
                </Button>
              </ConfirmDialog>
            </div>
          </div>
        </DialogActions>
      </div>
    </form>
  );
};

RemoveModuleModel.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = () => {
  return {};
};

const styles = (theme) => ({
  lableOutline: {
    zIndex: "9",
    background: "#fff",
    padding: "0px 5px 0px 6px",
    marginLeft: "-5px"
  },
  panel: {
    position: "fixed",
    width: 360,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    top: 0,
    height: "100%",
    minHeight: "100%",
    bottom: 0,
    right: 0,
    margin: 0,
    zIndex: 1000,
    padding: "55px 0px 0px",
    transform: "translate3d(360px,0,0)",
    // overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      transform: "translate3d(360px,0,0)",
      boxShadow: "none",
      "&.opened": {
        boxShadow: theme.shadows[5]
      }
    },
    transition: theme.transitions.create(["transform"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard
    }),
    "&.opened": {
      transform: "translateX(0)"
    }
  }
});

export default withStyles(styles)(connect(mapStateToProps)(RemoveModuleModel));
